// app/javascript/controllers/testimonials_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dot", "prev", "next"]

  connect() {
    console.log("testimonials controller connected")
    this.currentSlide = 0
    this.showSlide(this.currentSlide)
    this.startAutoAdvance()
  }

  disconnect() {
    this.stopAutoAdvance()
  }

  // Show a specific slide
  showSlide(index) {
    // Hide all slides
    this.slideTargets.forEach(slide => {
      slide.classList.remove('active')
    })
    
    // Remove active class from all dots
    this.dotTargets.forEach(dot => {
      dot.classList.remove('active')
    })
    
    // Show the selected slide
    this.slideTargets[index].classList.add('active')
    
    // Activate the corresponding dot
    this.dotTargets[index].classList.add('active')
    
    // Update currentSlide
    this.currentSlide = index
  }

  // Next slide action
  next() {
    const nextIndex = (this.currentSlide + 1) % this.slideTargets.length
    this.showSlide(nextIndex)
  }

  // Previous slide action
  prev() {
    const prevIndex = (this.currentSlide - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(prevIndex)
  }

  // Go to specific slide (for dots)
  goTo(event) {
    const slideIndex = parseInt(event.currentTarget.getAttribute('data-index'))
    this.showSlide(slideIndex)
  }

  // Auto-advance functionality
  startAutoAdvance() {
    this.autoAdvanceInterval = setInterval(() => {
      this.next()
    }, 5000)
  }

  stopAutoAdvance() {
    if (this.autoAdvanceInterval) {
      clearInterval(this.autoAdvanceInterval)
    }
  }

  // Pause auto-advance on hover (optional enhancement)
  pauseAutoAdvance() {
    this.stopAutoAdvance()
  }

  // Resume auto-advance when not hovering (optional enhancement)
  resumeAutoAdvance() {
    this.startAutoAdvance()
  }
}

